<template>
  <div class="tour-img-slider-mobile">
    <VueSlickCarousel ref="tourSliderImg" v-bind="imageSettings" @beforeChange="onBeforeChange">
      <div v-for="(image, idx) in images" :key="idx">
        <div @click="handleClick">
          <TourMobleImg :image="image" :index="idx" />
        </div>
      </div>
    </VueSlickCarousel>
    <button class="slider-previous" :style="isFirst ? { display: 'none' } : {}" @click="goToPrevious">
      <span class="slider-icon" />
    </button>
    <button class="slider-next" :style="isLast ? { display: 'none' } : {}" @click="goToNext">
      <span class="slider-icon" />
    </button>
  </div>
</template>

<script>
import { delay } from '~/helpers/ui'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import TourMobleImg from "@/components/containers/tour/TourMobleImg"

export default {
  name: 'TourMobileSlider',
  components: {
    VueSlickCarousel,
    TourMobleImg,
  },
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  computed: {
    isFirst() {
      return this.curIndex === 0
    },
    isLast() {
      return this.curIndex === this.images.length - 1
    },
  },
  data () {
    return {
      curIndex: 0,
      imageSettings: {
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        focusOnSelect: false
      }
    }
  },
  methods: {
    handleClick () {
      this.$emit('clickImg')
    },
    onBeforeChange (oldSlideIndex, newSlideIndex) {
      this.curIndex = newSlideIndex
      this.$emit('updateIdx', this.curIndex)
    },
    goToNext () {
      delay(() => {
        this.$refs?.tourSliderImg.next()
      })
    },
    goToPrevious () {
      delay(() => {
        this.$refs?.tourSliderImg.prev()
      })
    },
    goTo (idx) {
      this.$refs?.tourSliderImg.goTo(idx)
    }
  }
}
</script>

<style lang="scss" scoped>
.tour-img-slider-mobile {
  width: 100%;
  .slider-next,
  .slider-previous {
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    outline: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    box-sizing: border-box;
    .slider-icon {
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: 27px 44px;
      display: block;
      height: 32px;
      padding: 0 24px;
      width: 27px;
      box-sizing: border-box;
    }

    width: 60px;
    height: 60px;
    border-radius: 100%;
    transition: background-color 0.3s;

    // &:hover {
    //   opacity: 1;
    //   background-color: rgba(255, 255, 255, 0.5);
    // }

    &:before {
      content: "";

      top: 0;
      left: 0;
      position: absolute;

      width: 60px;
      height: 60px;
      border-radius: 100%;

      opacity: 0;
      z-index: 30;
      pointer-events: none;
      transition: opacity 0.5s;
      background-color: rgba(255, 255, 255, 0.5);
    }

    &:active:before {
      opacity: 1;
    }
  }
  .slider-previous {
    left: 0;
    .slider-icon {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22 22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E");
    }
  }
  .slider-next {
    right: 0;
    .slider-icon {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22 5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E");
    }
  }
}
</style>

